import React from 'react';
import { useLocation } from 'react-router-dom';
import {
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBRow,
    MDBCol
} from 'mdb-react-ui-kit';
import {QRCode} from "antd";

function QrEventParticipantMyView() {
    const location = useLocation();
    const state = location.state || {};

    // ⭐ 구조분해를 여기서!
    const { uuid, name, affiliation, contactNumber, email, eventName } = state;

    if (!uuid) {
        // 디버깅용
        console.log('location.state', state);
        return <p style={{ textAlign: 'center', marginTop: '20px' }}>참가자 정보가 없습니다.</p>;
    }


    return (
        <MDBContainer className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', backgroundColor: '#f4f4f4' }}>
            <MDBCard className="p-4" style={{ maxWidth: '450px', width: '100%', borderRadius: '15px', backgroundColor: '#ffffff', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
                <MDBCardBody>
                    <MDBCardTitle className="text-center mb-4" style={{ color: '#4CAF50', fontWeight: 'bold' }}>
                        참가자 정보
                    </MDBCardTitle>

                    <MDBRow className="mb-3">
                        <MDBCol size="4">
                            <strong>행사명:</strong>
                        </MDBCol>
                        <MDBCol size="8">
                            <MDBCardText>{eventName.replaceAll('_', ' ')}</MDBCardText>
                        </MDBCol>
                    </MDBRow>

                    <MDBRow className="mb-3">
                        <MDBCol size="4">
                            <strong>성함:</strong>
                        </MDBCol>
                        <MDBCol size="8">
                            <MDBCardText>{name}</MDBCardText>
                        </MDBCol>
                    </MDBRow>

                    <MDBRow className="mb-3">
                        <MDBCol size="4">
                            <strong>소속:</strong>
                        </MDBCol>
                        <MDBCol size="8">
                            <MDBCardText>{affiliation || '없음'}</MDBCardText>
                        </MDBCol>
                    </MDBRow>

                    <MDBRow className="mb-3">
                        <MDBCol size="4">
                            <strong>연락처:</strong>
                        </MDBCol>
                        <MDBCol size="8">
                            <MDBCardText>{contactNumber}</MDBCardText>
                        </MDBCol>
                    </MDBRow>

                    <MDBRow className="mb-4">
                        <MDBCol size="4">
                            <strong>이메일:</strong>
                        </MDBCol>
                        <MDBCol size="8">
                            <MDBCardText>{email}</MDBCardText>
                        </MDBCol>
                    </MDBRow>

                    <div className="d-flex flex-column align-items-center">
                        <h6 className="mb-3" style={{ color: '#4CAF50' }}>QR 코드</h6>
                        <div style={{ padding: '10px', border: '2px solid #4CAF50', borderRadius: '10px' }}>
                            <QRCode
                                value={uuid}
                                size={248}
                                fgColor="#000000"
                                bgColor="#ffffff"
                            />
                        </div>
                    </div>
                </MDBCardBody>
            </MDBCard>
        </MDBContainer>
    );
}

export default QrEventParticipantMyView;